export const tablescroll = (() => {
    function checkOverflow() {
        const tableWrappers = document.querySelectorAll('.tablewrapper');
        tableWrappers.forEach((tableWrapper) => {
            const shadowWrapper = tableWrapper.closest('.shadowwrapper');
            // Check if the content is overflowing
            const isOverflowing = tableWrapper.scrollWidth > tableWrapper.clientWidth;
            // Toggle the `is-overflowing` class based on the condition
            tableWrapper.classList.toggle('tablewrapper-overflowing', isOverflowing);

            // Add scroll event listener to the .tablewrapper element for horizontal scroll
            tableWrapper.addEventListener('scroll', function () {
                shadowWrapper.classList.add('shadowwrapper-touched');
                // Check if scrolled from left position
                const isScrolledHorizontally = tableWrapper.scrollLeft > 0;
                tableWrapper.classList.toggle('tablewrapper-isScrolled', isScrolledHorizontally);

                // Check if reached the far right end
                const isAtFarRight = tableWrapper.scrollWidth - tableWrapper.clientWidth === tableWrapper.scrollLeft;
                tableWrapper.classList.toggle('tablewrapper-overflowing', !isAtFarRight);
            });
        });

        const tabsWrapper = document.querySelector('.tabsWrapper-inner');
        if (tabsWrapper) {
            // Check if the content is overflowing
            const isOverflowingTabs = tabsWrapper.scrollWidth > tabsWrapper.clientWidth;
            // Toggle the `is-overflowing` class based on the condition
            tabsWrapper.classList.toggle('tabsWrapper-inner-overflowing', isOverflowingTabs);

            // Add scroll event listener to the .tabsWrapper-inner element for horizontal scroll
            tabsWrapper.addEventListener('scroll', function () {
                // Check if scrolled from left position
                const isScrolledHorizontallyTabs = tabsWrapper.scrollLeft > 0;
                tabsWrapper.classList.toggle('tabsWrapper-inner-isScrolled', isScrolledHorizontallyTabs);

                // Check if reached the far right end
                const isAtFarRightTabs = tabsWrapper.scrollWidth - tabsWrapper.clientWidth === tabsWrapper.scrollLeft;
                tabsWrapper.classList.toggle('tabsWrapper-inner-overflowing', !isAtFarRightTabs);
            });
        }
    }

    // Run the function on initial load
    checkOverflow();
    // Optionally, run the function on window resize to ensure accuracy
    window.addEventListener('resize', checkOverflow);
    window.checkOverflow = checkOverflow;
})();

window.attachScrollEventListeners = function (selector) {
    setTimeout(() => {
        window.checkOverflow();
    }, 100);
};
